import { render, staticRenderFns } from "./WithdrawalAddress.vue?vue&type=template&id=3297f0ea&"
import script from "./WithdrawalAddress.vue?vue&type=script&lang=js&"
export * from "./WithdrawalAddress.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalAddress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports